import React from 'react';
import './App.css';
import './VintageTime'
import VintageTime from './VintageTime';

function App() {
  return (
    <div className="App">
      <VintageTime/>
    </div>
  );
}

export default App;
